/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2500
 */

var r = require(/* 997 */"./2501/997")
var /* [auto-meaningful-name] */Object$prototype$hasOwnProperty = Object.prototype.hasOwnProperty
module.exports = function (e) {
  var /* [auto-meaningful-name] */this$__data__ = this.__data__
  return r ? undefined !== this$__data__[e] : Object$prototype$hasOwnProperty.call(this$__data__, e)
}
